import { ReactElement } from 'react'
import AccountCardMFE from 'account-card-mfe'
import getMfeConfig from 'helpers/getMFEConfig'
import featureFlags from 'const/featureFlags'
import { AccountCardHandlers } from 'account-card-mfe/lib/mfe/AccountCardMFE/AccountCardMFE.types'
import useCTAHandlers from '../actions/useCTAHandlers'
import { CardColumn } from '../subcomponents'

interface AccountCardProps {
  accountId: string
  cardIndex: number
}

const AccountCard = ({
  accountId,
  cardIndex
}: AccountCardProps): ReactElement => {
  const mfeConfig = getMfeConfig('mfe')
  const {
    isCardActivationEnabled,
    isCBREnabled,
    isRewardsDeeplinkEnabled,
    isAccountUpgradingMessageEnabled,
    isPromotionsMfeEnabled,
    isDigitalCollectionsExperienceEnabled,
    isLoanNickNameModalEnabled,
    isUPAGAutopaySectionEnabled
  } = featureFlags

  const handlers = useCTAHandlers(accountId)

  const eventHandlers: AccountCardHandlers = {
    handleActivityClick: handlers.handleActivityClick,
    handleDetailsClick: handlers.handleDetailsClick,
    handleMAPClick: handlers.handleMAPClick,
    handleAccountServicesClick: handlers.handleAccountServicesClick,
    handleRewardsClick: isRewardsDeeplinkEnabled
      ? handlers.handleRewardsClick
      : undefined,
    handleStatementsClick: handlers.handleStatementsClick,
    handleCBRClick: isCBREnabled ? handlers.handleCBRClick : undefined,
    handlePromotionsClick: isPromotionsMfeEnabled
      ? handlers.handlePromotionsClick
      : undefined,
    handleRegisterAccountClick: handlers.handleRegisterAccountClick,
    handleViewPaymentPlanOrOption: handlers.handleCollectionClick,
    handleAutopayClick: handlers.handleAutopayClick
  }

  return (
    <CardColumn $cardIndex={cardIndex}>
      <AccountCardMFE
        isQueryClientPresent
        mfeConfig={mfeConfig}
        accountId={accountId}
        featureFlags={{
          isAccountUpgradingMessageEnabled,
          isCardActivationEnabled,
          isCBREnabled,
          isDigitalCollectionsExperienceEnabled,
          isIRLEnabled: featureFlags.isIRLEnabled,
          isLoanNickNameModalEnabled,
          isUPAGAutopaySectionEnabled,
          isNotificationsEnabled: true,
          isPreDeliveryMessageEnabled: true
        }}
        eventHandlers={eventHandlers}
        handleAccountLink={handlers.handleAccountClick}
        shouldCallCreditAccountsQuery
      />
    </CardColumn>
  )
}

export default AccountCard
